module.exports = __webpack_public_path__ + "media/tsemppiaani4.6ceaf4a6.wav";